import type {ThunkResult} from "../../app/reducers/IMainAppState";
import {APIPost} from "../../shared/actions/FetchActions";
import {AUTHENTICATION_API_PATH} from "../../confs/APIConfig";

export function ForgetPassword(email: string): ThunkResult<Promise<void>> {
    return async (dispatch) => {
        const fetchResult: Response = await dispatch(APIPost(`${AUTHENTICATION_API_PATH}/action/_forgot`, {
            body: JSON.stringify({
                email
            })
        }));
        return await fetchResult.json();
    }
}

export function ResetPassword(resetToken: string, password: string): ThunkResult<Promise<void>> {
    return async (dispatch) => {
        const fetchResult: Response = await dispatch(APIPost(`${AUTHENTICATION_API_PATH}/action/_reset`, {
            body: JSON.stringify({
                resetToken,
                password
            })
        }));
        return await fetchResult.json();
    }
}
